/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { openHelp } from '~/store/modules/help/actions';
import { Icon, Button } from '~/elements';
import devices from '~/styles/devices';
import { GPlay, GPlayLight, AppStore, AppStoreLight } from '~/assets/';
import logoCaixaRodaPe from '../../assets/jvcef/logo-caixa-rodape.svg';
import { VRPAT, JVCEF } from '~/config/constants';

const Container = styled(Grid).attrs({ container: true })`
  justify-content: center;
  padding: 20px 0;
  background-color: rgba(0, 0, 0, 0.08);
  @media (max-width: ${devices.tablet}) {
    display: none !important;
  }
`;

const Wrapper = styled(Grid).attrs({ item: true })`
  width: 100%;
  max-width: 1280px;
  padding: 0 32px;
  overflow: hidden;
`;

const Title = styled.h3`
  color: ${({ theme }) => theme.colors.white};
  font-weight: bold;
  min-height: 36px;
  border-bottom: 3px solid ${({ theme }) => theme.colors.secondary};
  display: inline-block;
  font-size: 16px;
`;

const UL = styled.div`
  padding: 0;
`;

const LI = styled.div`
  font-size: 16px;
  margin-top: 16px;
  list-style: none;
  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.white};
  }
`;

const SocialLink = styled(Grid).attrs({ item: true })`
  font-size: 32px;
  a {
    color: ${({ theme }) => theme.colors.white};
  }
`;

const ImgFooterLogo = styled.div`
  margin-bottom: 4px;
`;

const Copyright = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.white};
  margin: 20px 0;
  a {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

const Footer = () => {
  const dispatch = useDispatch();
  const issuer = useSelector(state => state?.issuer);
  const btnStyle = issuer?.button?.primary?.style;
  const isVR = issuer.name === VRPAT;
  const currentYear = new Date().getFullYear();

  return (
    <Container>
      <Wrapper>
        <Grid
          container
          style={{
            justifyContent: isVR ? 'unset' : 'center',
            alignItems: 'center',
          }}
        >
          <Grid
            hidden={!isVR}
            item
            xs={12}
            sm={6}
            md={3}
            style={{ padding: '32px 0' }}
          >
            <Title>INSTITUCIONAL VR</Title>
            <UL>
              <LI>
                <a
                  href="https://www.vr.com.br/institucional-vr/historia-da-vr.htm"
                  target="_blank"
                >
                  História da VR
                </a>
              </LI>
              <LI>
                <a
                  href="https://www.vr.com.br/institucional-vr/historia-da-vr.htm"
                  target="_blank"
                >
                  Trabalhe Conosco
                </a>
              </LI>
              <LI>
                <a
                  href="https://www.vr.com.br/institucional-vr/vr-na-midia.htm"
                  target="_blank"
                >
                  Imprensa
                </a>
              </LI>
              <LI>
                <a href="https://blog.vr.com.br/" target="_blank">
                  Blog
                </a>
              </LI>
              <LI>
                <a
                  href="https://www.vr.com.br/data/files/CE/87/A4/EE/23894710FAA7F537EB5DCCA8/Programa%20de%20integridade%20VR.pdf"
                  target="_blank"
                >
                  Programa de Integridade
                </a>
              </LI>
            </UL>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={isVR ? 3 : 6}
            style={{ padding: '32px 0' }}
          >
            <Title>
              {isVR ? (
                'BAIXE O APP VR'
              ) : (
                <>
                  BAIXE O APLICATIVO <br />
                  {issuer?.app?.name}
                </>
              )}
            </Title>
            <UL>
              <LI>
                <a href={issuer?.app?.ios} target="_blank">
                  <img src={!isVR ? AppStoreLight : AppStore} alt="" />
                </a>
              </LI>
              <LI>
                <a href={issuer?.app?.android} target="_blank">
                  <img src={!isVR ? GPlayLight : GPlay} alt="" />
                </a>
              </LI>
            </UL>
          </Grid>
          <Grid
            hidden={!isVR}
            item
            xs={12}
            sm={6}
            md={2}
            style={{ padding: '32px 0' }}
          />
          <Grid item xs={12} sm={6} md={4} style={{ padding: '32px 0' }}>
            {isVR && (
              <Grid
                container
                spacing={3}
                style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}
              >
                <SocialLink>
                  <a
                    href="https://www.facebook.com/VRBeneficios/"
                    target="_blank"
                  >
                    <Icon icon={['fab', 'facebook-f']} />
                  </a>
                </SocialLink>
                <SocialLink>
                  <a href="https://twitter.com/vrbeneficios" target="_blank">
                    <Icon icon={['fab', 'twitter']} />
                  </a>
                </SocialLink>
                <SocialLink>
                  <a
                    href="https://www.instagram.com/vrbeneficios/?hl=pt-br"
                    target="_blank"
                  >
                    <Icon icon={['fab', 'instagram']} />
                  </a>
                </SocialLink>
                <SocialLink>
                  <a
                    href="https://www.linkedin.com/company/vrbeneficios/?originalSubdomain=pt"
                    target="_blank"
                  >
                    <Icon icon={['fab', 'linkedin-in']} />
                  </a>
                </SocialLink>
                <SocialLink>
                  <a
                    href="https://www.youtube.com/channel/UCmNW3Md8IHDoM6Z4D_68Pdw"
                    target="_blank"
                  >
                    <Icon icon={['fab', 'youtube']} />
                  </a>
                </SocialLink>
              </Grid>
            )}
            <Copyright>
              {issuer.name === JVCEF && (
                <ImgFooterLogo>
                  <img src={logoCaixaRodaPe} alt="logo caixa" />
                </ImgFooterLogo>
              )}
              © {currentYear} {issuer.copyrightCompany} - CNPJ {issuer.cnpj} -
              Todos os direitos reservados{' '}
              <a href={issuer?.terms?.privacity?.value} target="_blank">
                {issuer?.terms?.privacity?.name}
              </a>
              <br />
              <br />
              <Button
                color={btnStyle}
                label="Precisa de ajuda ou atendimento?"
                onClick={() => dispatch(openHelp())}
              />
            </Copyright>
          </Grid>
        </Grid>
      </Wrapper>
    </Container>
  );
};

export default Footer;
